export enum SelectedTimelineBlockVariants {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  FULL_DAY = 'FULL_DAY',
}
